<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container fluid>
            <v-card>
                <v-card-text>
                    <!-- วันที่จัดส่งสินค้า-->
                    <v-layout wrap>
                        <v-flex text-right mt-2 mr-3>
                            <v-btn fab small @click="previDate" color="orange accent-3"
                                :disabled="nowDate == dateStart ? true : false" 
                                :dark="nowDate == dateStart ? false : true">
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex lg2 md2 sm3 xs6>
                            <v-menu v-model="menuDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="dateStart" label="วันที่ส่งสินค้า:" v-on="on" 
                                    color="orange accent-3"></v-text-field>
                                </template>
                                <v-date-picker v-model="dateStart" @input="menuDate = false" color="orange accent-3"
                                @change="getCarSchedule" :min="nowDate" no-title></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex mt-2 ml-3>
                            <v-btn fab small @click="nextDate" color="orange accent-3" dark>
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <!-- ข้อมูลการจัดรถระหว่างวัน(online) -->
                    <v-layout>
                        <v-flex text-center>
                            <v-dialog v-model="showScheOnline" persistent max-width="500">
                                <template v-slot:activator="{ on }">
                                    <v-btn color="orange accent-3" dark v-on="on">ข้อมูลการจัดรถระหว่างวัน(Online)</v-btn>
                                </template>
                                <v-card>
                                    <v-card-text>
                                        <br>
                                        <v-layout wrap>
                                            <v-flex xs4 pr-2>
                                                <v-menu v-model="menuDateStart" :close-on-content-click="false" 
                                                :nudge-right="40" transition="scale-transition">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field v-model="dateOnStart" label="วันที่ส่งสินค้าเริ่ม:" v-on="on" 
                                                        color="orange accent-3" readonly></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="dateOnStart" @input="menuDateStart = false" color="orange accent-3"
                                                    @change="getScheOnline" no-title :max="dateOnEnd" :min="nowDate"></v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex xs4 pr-2>
                                                <v-menu v-model="menuDateEnd" :close-on-content-click="false" 
                                                :nudge-right="40" transition="scale-transition">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field v-model="dateOnEnd" label="วันที่ส่งสินค้าถึง:" v-on="on" 
                                                        color="orange accent-3" readonly></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="dateOnEnd" @input="menuDateEnd = false" color="orange accent-3"
                                                    @change="getScheOnline" no-title :min="dateOnStart"></v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex xs4>
                                                <v-select @change="filterRegNum" :items="itemRegNum" v-model="selectRegNum" label="ทะเบียนรถ:"></v-select>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex>
                                                <v-data-table :headers="headCarS" :items="carInfo" dense 
                                                hide-default-footer mobile-breakpoint :items-per-page="numPage">
                                                    <template v-slot:no-data>
                                                        <v-progress-linear v-if="searchData"  height="10px" 
                                                        v-slot:progress color="orange accent-3" 
                                                        indeterminate></v-progress-linear>
                                                        <v-flex v-if="noData">
                                                            <strong><font color="red">ไม่พบข้อมูล</font></strong>
                                                        </v-flex>
                                                    </template>
                                                    <template v-slot:item.arrDate="{ item }">
                                                        <v-layout v-for="(el,i) in item.arrDate" :key="i">
                                                            <v-flex>{{el}}</v-flex>
                                                        </v-layout>
                                                    </template>
                                                    <template v-slot:item.custOnline="{ item }">
                                                        <v-layout v-for="(el,i) in item.custOnline" :key="i">
                                                            <v-flex><font :color="el < 5 ? 'green' : 'red'">{{el}}</font></v-flex>
                                                        </v-layout>
                                                    </template>
                                                    <template v-slot:item.custOther="{ item }">
                                                        <v-layout v-for="(el,i) in item.custOther" :key="i">
                                                            <v-flex>{{el}}</v-flex>
                                                        </v-layout>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>
                                        <br>
                                        <v-layout>
                                            <v-flex text-center>
                                                <v-btn @click="closeScheOnline" text>ปิด</v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </v-flex>
                    </v-layout>
                    <!-- เช็คสถานะการส่งสินค้า -->
                    <v-layout>
                        <v-flex text-right>
                            <v-btn text @click="openTrack" color="orange accent-3">
                                <v-icon>mdi-cube-send</v-icon>เช็คสถานะการส่งสินค้า
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <template v-if="showPage">
                <!-- ตารางรถเล็ก -->
                <v-card>
                    <v-card-title><v-layout><v-flex text-center><v-icon>mdi-car</v-icon>รถเล็ก</v-flex></v-layout></v-card-title>
                    <v-layout wrap justify-center>
                        <v-flex lg2 md4 sm5 xs12 mt-2 mr-2 ml-2 v-for="(item,j) in carSmall" :key="j">
                            <v-hover v-slot:default="{ hover }">
                                <v-card :elevation="hover ? 8 : 2">
                                    <v-card-text>
                                        <v-layout wrap>
                                            <v-flex><strong>ทะเบียนรถ:</strong></v-flex>
                                            <v-flex text-right>{{item.regNum}}</v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>Zone:</strong></v-flex>
                                            <v-flex text-right>{{item.zone.toString()}}</v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>ปริมาตรสินค้าบนรถ:</strong></v-flex>
                                            <v-flex text-right>
                                                {{item.volume.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                            </v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>เลขที่ใบจัดรถ:</strong></v-flex>
                                            <v-flex text-right>{{item.transNo}}</v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>จำนวนที่ส่ง:</strong></v-flex>
                                            <v-flex text-right>{{item.count}}</v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong><font :color="item.countD01 < 5 ? 'green' : 'red'">ลูกค้าออนไลน์:</font></strong></v-flex>
                                            <v-flex text-right><font :color="item.countD01 < 5 ? 'green' : 'red'">{{item.countD01}}</font></v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>ลูกค้าอื่น ๆ:</strong></v-flex>
                                            <v-flex text-right>{{item.countOther}}</v-flex>
                                        </v-layout>
                                    </v-card-text>
                                    <v-fade-transition>
                                        <v-overlay v-if="hover" absolute>
                                            <v-layout>
                                                <v-flex text-right mr-2>
                                                    <v-btn @click="manageCar(item)" color="orange accent-3">จัดรถ</v-btn>
                                                </v-flex>
                                                <v-flex v-if="item.count > 0">
                                                    <v-btn @click="viewProd(item)" color="orange accent-3">รายละเอียด</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-overlay>
                                    </v-fade-transition>
                                </v-card>
                            </v-hover>
                        </v-flex>
                    </v-layout>
                    <br>
                </v-card>

                <!-- ตารางรถใหญ่ -->
                <v-card>
                    <v-card-title><v-layout><v-flex text-center><v-icon>mdi-bus</v-icon>รถใหญ่</v-flex></v-layout></v-card-title>
                    <v-layout wrap justify-center>
                        <v-flex lg2 md4 sm5 xs12 mt-2 mr-2 ml-2 v-for="(item,j) in carLarge" :key="j">
                            <v-hover v-slot:default="{ hover }">
                                <v-card :elevation="hover ? 8 : 2">
                                    <v-card-text>
                                        <v-layout wrap>
                                            <v-flex><strong>ทะเบียนรถ:</strong></v-flex>
                                            <v-flex text-right>{{item.regNum}}</v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>Zone:</strong></v-flex>
                                            <v-flex text-right>{{item.zone.toString()}}</v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>ปริมาตรสินค้าบนรถ:</strong></v-flex>
                                            <v-flex text-right>
                                                {{item.volume.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                            </v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>เลขที่ใบจัดรถ:</strong></v-flex>
                                            <v-flex text-right>{{item.transNo}}</v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>จำนวนที่ส่ง:</strong></v-flex>
                                            <v-flex text-right>{{item.count}}</v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong><font :color="item.countD01 < 5 ? 'green' : 'red'">ลูกค้าออนไลน์:</font></strong></v-flex>
                                            <v-flex text-right><font :color="item.countD01 < 5 ? 'green' : 'red'">{{item.countD01}}</font></v-flex>
                                        </v-layout>
                                        <v-layout wrap>
                                            <v-flex><strong>ลูกค้าอื่น ๆ:</strong></v-flex>
                                            <v-flex text-right>{{item.countOther}}</v-flex>
                                        </v-layout>
                                    </v-card-text>
                                    <v-fade-transition>
                                        <v-overlay v-if="hover" absolute>
                                            <v-layout>
                                                <v-flex text-right mr-2>
                                                    <v-btn @click="manageCar(item)" color="orange accent-3">จัดรถ</v-btn>
                                                </v-flex>
                                                <v-flex v-if="item.count > 0">
                                                    <v-btn @click="viewProd(item)" color="orange accent-3">รายละเอียด</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-overlay>
                                    </v-fade-transition>
                                </v-card>
                            </v-hover>
                        </v-flex>
                    </v-layout>
                    <br>
                </v-card>
            </template>

            <v-dialog v-model="showView">
                <v-card>
                    <v-data-table :headers="listHeader" :items="manageList" class="elevation-1" 
                    dense :items-per-page="100" hide-default-footer sort-by="serviceTime">
                        <template v-slot:no-data>
                            <v-progress-linear v-if="searchData"  height="10px" v-slot:progress color="orange accent-3" 
                            indeterminate></v-progress-linear>
                            <v-flex v-if="noData">
                                <strong><font color="red">ไม่พบข้อมูล</font></strong>
                            </v-flex>
                        </template>
                    </v-data-table>
                </v-card>
            </v-dialog>

        </v-container>
        <!-- Dialog progress -->
        <v-dialog v-model="showDialogProgress" max-width="80" persistent>
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-progress-circular :size="30" color="orange accent-5" indeterminate></v-progress-circular>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>

        <!-- Dialog Error -->
        <v-dialog v-model="showDialogError" width="unset">
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-icon color="red" :size="45">mdi-close-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                {{msgError}}
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>
        <!-- <div>{{ carSmall }}</div> -->
        <!-- <hr> -->
        <!-- <div>{{ carLarge }}</div> -->
        <!-- <hr> -->
        <!-- <div>{{ zone }}</div> -->
    </v-app>
</template>
<script>
import mainMenu from '@/components/mainMenu'
import {db} from '@/firebase'
import {loadFleet} from '@/components/fleet'
// import config from '@/components/config'
import axios from 'axios'
import {reportError} from '@/components/report'
export default {
    components:{
        mainMenu
    },
    data(){
        return{
            itemRegNum: [],
            selectRegNum: '',
            numPage: 20,
            headCarS: [
                { text: 'ทะเบียนรถ', sortable: false, align: 'left', value: 'regNum' },
                { text: 'วันที่', sortable: false, align: 'left', value: 'arrDate' },
                { text: 'ลูกค้าออนไลน์', sortable: false, align: 'center', value: 'custOnline' },
                { text: 'ลูกค้าอื่น ๆ', sortable: false, align: 'center', value: 'custOther' },
            ],
            cloneCarInfo: [],
            carInfo: [],
            dateOnEnd: '',
            menuDateEnd: false,
            dateOnStart: '',
            menuDateStart: false,
            showScheOnline: false,
            showPage: false,
            // webPath:config.webPath,
            searchData: false,
            noData: true,
            showDialogProgress: false,
            showDialogError: false,
            msgError: '',

            nowDate: new Date().toISOString().substr(0,10),
            menuDate: false,
            dateStart: new Date().toISOString().substr(0,10),

            regNumHeader: [
                { text: 'ทะเบียนรถ', sortable: false, align: 'left', value: 'regNum' },
                { text: 'ปริมาตรสินค้าบนรถ', sortable: false, align: 'right', value: 'sumVolume' },
                { text: 'จำนวนที่ส่ง(ที่)', sortable: false, align: 'right', value: 'docEntry' },
                { text: '', sortable: false, align: 'center', value: 'button' },
            ],
            carSmall: [],
            carLarge: [],
            regNumItem: [],
            regNumDetail: [],

            showView: false,

            listHeader: [
                { text: 'รหัสร้านค้า', sortable: false, align: 'left', value: 'cardCode' },
                { text: 'เลขที่ SO', sortable: false, align: 'left', value: 'docNum' },
                { text: 'ชื่อร้านค้า', sortable: false, align: 'left', value: 'cardName' },
                // { text: 'ที่อยู่ร้านค้า', sortable: false, align: 'left', value: 'address1' },
                { text: 'ชื่อลูกค้า', sortable: false, align: 'left', value: 'custName' },
                { text: 'ที่อยู่ลูกค้า', sortable: false, align: 'left', value: 'address2' },
                { text: 'เวลาจัดส่ง', sortable: false, align: 'left', value: 'serviceTime' },
            ],
            manageList: [],

            volume: 0,
            zone: [],
        }
    },
    methods:{

        filterRegNum(){
            this.carInfo = this.cloneCarInfo.filter(e=>e.regNum.slice(this.selectRegNum,this.selectRegNum.length) == this.selectRegNum)
        },

        closeScheOnline(){
            this.dateOnStart = ""
            this.dateOnEnd = ""
            this.carInfo = []
            this.selectRegNum = ""
            this.showScheOnline = false
            this.searchData = false
            this.noData = true
        },
        
        getScheOnline(){
            let app = this
            app.carInfo = []
            app.cloneCarInfo = []
            if(app.dateOnStart && app.dateOnEnd){
                app.searchData = true
                app.noData = false
                axios.post(app.webPath+'deliveryWebService.asmx/GetScheCar', {
                    dateS: app.dateOnStart,
                    dateE: app.dateOnEnd
                })
                .then(response=>{
                    let result = JSON.parse(response.data.d)
                    let small = sessionStorage.carSmall.split(",")
                    let large = sessionStorage.carLarge.split(",")

                    let arrSmall = []
                    small.forEach(rec=>{
                        arrSmall.push({ regNum: rec, arrDate: [], custOnline: [], custOther: [] })
                    })
                    let arrLarge = []
                    large.forEach(rec=>{
                        arrLarge.push({ regNum: rec, arrDate: [], custOnline: [], custOther: [] })
                    })

                    let arr = []
                    let regNum = null
                    let date = null
                    let countOnline = 0
                    let countOther = 0
                    let count = 0

                    for (let i = 0; i < result.length; i++) {
                        let j = i - 1
                        if(result[i].regNum != regNum || result[i].delDate != date){
                            if(count > 0){
                                arr.push({ regNum: regNum, date: date, countOnline: countOnline, countOther: countOther })
                            }
                            regNum = result[i].regNum
                            date = result[i].delDate
                            countOnline = 0
                            countOther = 0
                            if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                            result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                countOnline = 1
                            }
                            else{
                                countOther = 1
                            }
                            count = 1
                        }
                        else{
                            if(result[i].custName){
                                if(result[i].custName == result[j].custName){
                                    count-1
                                    if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                                    result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                        countOnline-1
                                    }
                                    else{
                                        countOther-1
                                    }
                                }
                                else{
                                    count++
                                    if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                                    result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                        countOnline++
                                    }
                                    else{
                                        countOther++
                                    }
                                }
                            }
                            else{
                                if(result[i].cardName == result[j].cardName){
                                    count-1
                                    if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                                    result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                        countOnline-1
                                    }
                                    else{
                                        countOther-1
                                    }
                                }
                                else{
                                    count++
                                    if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                                    result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                        countOnline++
                                    }
                                    else{
                                        countOther++
                                    }
                                }
                            }
                        }
                    }
                    if(count > 0){
                        arr.push({ regNum: regNum, date: date, countOnline: countOnline, countOther: countOther })
                    }
                    arrSmall.forEach(a=>{
                        arr.forEach(b=>{
                            if(a.regNum == b.regNum){
                                a.arrDate.push(app.MsDateToDateVue(b.date))
                                a.custOnline.push(b.countOnline)
                                a.custOther.push(b.countOther)
                            }
                        })
                    })
                    arrLarge.forEach(a=>{
                        arr.forEach(b=>{
                            if(a.regNum == b.regNum){
                                a.arrDate.push(app.MsDateToDateVue(b.date))
                                a.custOnline.push(b.countOnline)
                                a.custOther.push(b.countOther)
                            }
                        })
                    })
                    let conArr = arrSmall.concat(arrLarge)
                    app.cloneCarInfo = [...conArr]
                    app.carInfo = app.cloneCarInfo
                    app.filterRegNum()
                    app.searchData = false
                })
                .catch(()=>{
                    app.searchData = false
                    app.noData = true
                })
            }
        },

        // วันก่อนหน้า
        previDate(){
                let date = new Date(this.dateStart)
                let nextDay = new Date(date)
                nextDay.setDate(date.getDate() - 1)
                this.dateStart = nextDay.toISOString().substr(0,10)
                this.getCarSchedule()
        },

        // วันถัดไป
        nextDate(){
            let date = new Date(this.dateStart)
            let nextDay = new Date(date)
            nextDay.setDate(date.getDate() + 1)
            this.dateStart = nextDay.toISOString().substr(0,10)
            this.getCarSchedule()
        },

        openTrack(){
            let routeData = this.$router.resolve({name: 'track'})
            window.open(routeData.href, "_blank")
        },

        // แสดงข้อมูลทะเบียน
        getRegNum(){
            this.showDialogProgress = true
            // Reads the per-plate documents in registerCar, not the legacy
            // carSmall / carLarge arrays -- see src/components/fleet.js.
            // loadFleet fills sessionStorage itself, which getCarSchedule below
            // still reads, and preserves the plate ordering the arrays had.
            loadFleet()
            .then(({small, large})=>{
                this.getCarSchedule()
                this.showPage = true

                let arrSmall = [""]
                small.forEach(rec=>{
                    arrSmall.push(rec)
                })
                let arrLarge = []
                large.forEach(rec=>{
                    arrLarge.push(rec)
                })
                this.itemRegNum = arrSmall.concat(arrLarge)
            })
            .catch(()=>{
                this.msgError = 'ไม่สามารถดึงเลขทะเบียนรถได้ กรุณาลองใหม่อีกครั้ง'
                this.showDialogError = true
            })
        },

        // แสดงตารางจัดรถ
        getCarSchedule(){
            /**
             * Fetches and processes the car schedule data for the specified date.
             * 
             * This method performs the following steps:
             * 1. Initializes the carSmall and carLarge arrays with default values for each registered car.
             * 2. Fetches the zone data from the database.
             * 3. Retrieves the car schedule data for the specified date from the web service.
             * 4. Processes the retrieved data to populate the carSmall and carLarge arrays with relevant details.
             * 5. Fetches and assigns zone information to each car based on the zipcode of the delivery addresses.
             * 6. Handles errors and displays appropriate messages to the user.
             * 
             * @returns {void}
             */
            let app = this
            app.showPage = false
            app.carSmall = []
            app.carLarge = []
            app.zone = []
            app.showDialogProgress = true
            let result = []

            // Fetching Car Data from Session Storage
            let small = sessionStorage.carSmall.split(",")
            let large = sessionStorage.carLarge.split(",")

            // Initializes the carSmall and carLarge arrays with default values for each registered car.
            small.forEach(rec=>{
                app.carSmall.push({ regNum: rec, transNo: '', loadDate: '', delDate: '', driver: '',
                docEntry: [], zone: [], volume: 0, count: 0, countD01: 0, countOther: 0 })
            })
            large.forEach(rec=>{
                app.carLarge.push({ regNum: rec, transNo: '', loadDate: '', delDate: '', driver: '',
                docEntry: [], zone: [], volume: 0, count: 0, countD01: 0, countOther: 0 })
            })

            // Sorting the carSmall and carLarge arrays by registration number.
            app.carSmall.sort((a, b) => a.regNum.localeCompare(b.regNum))
            app.carLarge.sort((a, b) => a.regNum.localeCompare(b.regNum))

            // Fetching Zone Data from Database
            db.collection("zone").doc("zone").get()
            .then(query=>{
                app.zone = query.data().list

                //Fetching Car Schedule Data from Web Service
                axios.post(app.webPath+'deliveryWebService.asmx/GetRegNumList', {
                    date: app.dateStart
                })
                .then(response=>{
                    // Parse the JSON response data from the web service and store it in the 'result' variable
                    result = JSON.parse(response.data.d)
                    // Initialize the variable to store the registration number of the car
                    let regNum = null
                    // Initialize the variable to store the transaction number associated with the car
                    let transNo = null
                    // Initialize the variable to store the loading date of the car
                    let loadDate = null
                    // Initialize the variable to store the delivery date of the car
                    let delDate = null
                    // Initialize the variable to store the driver's name associated with the car
                    let driver = null
                    // Initialize an empty array to store document entries related to the car
                    let docEntry = []
                    // Initialize an empty array to store document numbers associated with each car
                    let arrDocNum = []
                    // Initialize a counter for online customers (D01)
                    let countD01 = 0
                    // Initialize a counter for other customers
                    let countOther = 0
                    // Initialize a variable to keep track of the total volume of items processed
                    let volume = 0
                    // Initialize a counter variable to keep track of the number of items processed
                    let count = 0
                    // Initialize an empty array to store the processed car schedule data
                    let newArr = []
                    /**
                     * Processes the car schedule data to populate the newArr array with relevant details.
                     * 
                     * This loop performs the following steps:
                     * 1. Iterates through the result array to process each car schedule entry.
                     * 2. Checks if the current entry's registration number (regNum) is different from the previous one.
                     * 3. If different, it pushes the accumulated data for the previous car into the newArr array.
                     * 4. Initializes new variables for the current car's details.
                     * 5. If the registration number is the same as the previous one, it updates the accumulated data for the current car.
                     * 6. Handles the counting of online customers (D01) and other customers.
                     * 7. Updates the volume and count of items processed for the current car.
                     * 
                     * @param {Array} result - The array containing the car schedule data to be processed.
                     * @returns {void}
                     */
                    for (let i = 0; i < result.length; i++) {
                        let j = i - 1
                        if(result[i].regNum != regNum){
                            if(count > 0){
                                newArr.push({ regNum: regNum, transNo: transNo, loadDate: loadDate,
                                delDate: delDate, driver: driver, countD01: countD01, countOther: countOther,
                                docEntry: docEntry, volume: volume, count: count, arrDocNum: arrDocNum })
                            }
                            regNum = result[i].regNum
                            transNo = result[i].transNo
                            loadDate = result[i].loadDate
                            delDate = result[i].delDate
                            driver = result[i].driver
                            docEntry = []
                            docEntry.push(result[i].docEntry)
                            arrDocNum = []
                            arrDocNum.push(result[i])
                            countD01 = 0
                            countOther = 0
                            if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                            result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                countD01 = 1
                            }
                            else{
                                countOther = 1
                            }
                            volume = result[i].volume
                            count = 1
                        }
                        else{
                            arrDocNum.push(result[i])
                            if(result[i].custName){
                                if(result[i].custName == result[j].custName){
                                    volume += result[i].volume
                                    count-1
                                    if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                                    result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                        countD01-1
                                    }
                                    else{
                                        countOther-1
                                    }
                                }
                                else{
                                    docEntry.push(result[i].docEntry)
                                    volume += result[i].volume
                                    count++
                                    if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                                    result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                        countD01++
                                    }
                                    else{
                                        countOther++
                                    }
                                }
                            }
                            else{
                                if(result[i].cardName == result[j].cardName){
                                    volume += result[i].volume
                                    count-1
                                    if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                                    result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                        countD01-1
                                    }
                                    else{
                                        countOther-1
                                    }
                                }
                                else{
                                    docEntry.push(result[i].docEntry)
                                    volume += result[i].volume
                                    count++
                                    if(result[i].cardCode == "D01" || result[i].cardCode == "D10" || result[i].cardCode == "D11" ||
                                    result[i].cardCode == "D13" || result[i].cardCode == "D15"){
                                        countD01++
                                    }
                                    else{
                                        countOther++
                                    }
                                }
                            }
                        }
                    }
                    if(count > 0){
                        newArr.push({ regNum: regNum, transNo: transNo, loadDate: loadDate,
                        delDate: delDate, driver: driver, countD01: countD01, countOther: countOther,
                        docEntry: docEntry, volume: volume, count: count, arrDocNum: arrDocNum })
                    }
                    /**
                     * Processes the car schedule data for small cars and assigns zone information based on zip codes.
                     * 
                     * This method performs the following steps:
                     * 1. Iterates through the `carSmall` array to match each car with its corresponding entry in the `newArr` array.
                     * 2. Updates the car's details (volume, count, loadDate, delDate, transNo, driver, docEntry, arrDocNum, countD01, countOther) based on the matched entry.
                     * 3. If the car has associated document entries, it fetches the zip code for each document entry.
                     * 4. Assigns the zone to the car based on the fetched zip code.
                     * 5. Handles errors and displays appropriate messages to the user if the zip code data cannot be fetched.
                     * 
                     * @returns {void}
                     */
                    app.carSmall.forEach(a=>{
                        newArr.forEach(b=>{
                            if(b.regNum == a.regNum){
                                a.volume = b.volume
                                a.count = b.count
                                a.loadDate = b.loadDate
                                a.delDate = b.delDate
                                a.transNo = b.transNo
                                a.driver = b.driver
                                a.docEntry = b.docEntry
                                a.arrDocNum = b.arrDocNum
                                a.countD01 = b.countD01
                                a.countOther = b.countOther
                                if(b.docEntry.length > 0){
                                    b.docEntry.forEach(c => {
                                        /**
                                         * Fetches and processes the zip code for each document entry associated with the car.
                                         * 
                                         * This method performs the following steps:
                                         * 1. Initializes an empty array to store the zip code data.
                                         * 2. Sends a POST request to the web service to fetch the zip code for the current document entry.
                                         * 3. Parses the response data and extracts the zip code.
                                         * 4. Determines the zone based on the zip code.
                                         * 5. Updates the car's zone information if the zip code matches a known zone.
                                         * 6. Handles errors and displays appropriate messages to the user if the zip code data cannot be fetched.
                                         * 
                                         * @param {Array} b.docEntry - The array containing the document entries associated with the car.
                                         * @param {Object} a - The car object containing its details.
                                         * @param {Object} app - The Vue instance containing the application data and methods.
                                         * @returns {void}
                                         */
                                        let zipcode = [];
                                        axios.post(this.webPath + 'deliveryWebService.asmx/GetZipcode', {
                                            docEntry: c
                                        })
                                        .then(res => {
                                            zipcode = JSON.parse(res.data.d);
                                            let code = '';
                                            if (zipcode[0].address2 != null) {
                                                code = zipcode[0].address2.trim().slice(-5);
                                                let newPos = app.zone.findIndex(x => x.zipcode == code);
                                                if (newPos != -1) {
                                                    a.zone.push(app.zone[newPos].zone);
                                                    a.zone = a.zone.filter((item, pos) => a.zone.indexOf(item) == pos);
                                                }
                                            }
                                        })
                                        .catch((error)=> {
                                            reportError('GetZipcode(carSmall) failed', error)
                                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetZipcode(carSmall) has error"
                                            app.showDialogError = true
                                        })
                                    })
                                }
                            }
                        })
                    })
                    app.carLarge.forEach(a=>{
                        newArr.forEach(b=>{
                            if(b.regNum == a.regNum){
                                a.volume = b.volume
                                a.count = b.count
                                a.transNo = b.transNo
                                a.loadDate = b.loadDate
                                a.delDate = b.delDate
                                a.driver = b.driver
                                a.docEntry = b.docEntry
                                a.arrDocNum = b.arrDocNum
                                a.countD01 = b.countD01
                                a.countOther = b.countOther
                                if(b.docEntry.length > 0){
                                    b.docEntry.forEach(c=>{
                                        let zipcode = []
                                        axios.post(this.webPath+'deliveryWebService.asmx/GetZipcode',{
                                            docEntry: c
                                        })
                                        .then(res=>{
                                            zipcode = JSON.parse(res.data.d)
                                            // console.log(zipcode[0])
                                            let code = ''
                                            if(zipcode[0].address2 != null){
                                                code = zipcode[0].address2.trim().slice(-5)
                                                let newPos = app.zone.findIndex(x=>x.zipcode == code)
                                                if(newPos != -1){
                                                    a.zone.push(app.zone[newPos].zone)
                                                    a.zone = a.zone.filter((item, pos)=>a.zone.indexOf(item) == pos)
                                                }
                                            }
                                            else{
                                                // app.$set(a,"zipcode",zipcode[0].address1.trim().slice(-5))
                                                code = zipcode[0].address1.trim().slice(-5)
                                                let newPos = app.zone.findIndex(x=>x.zipcode == code)
                                                if(newPos != -1){
                                                    a.zone.push(app.zone[newPos].zone)
                                                    a.zone = a.zone.filter((item, pos)=>a.zone.indexOf(item) == pos)
                                                }
                                            }
                                        })
                                        .catch((error)=> {
                                            reportError('GetZipcode(carLarge) failed', error)
                                            app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetZipcode(carLarge) has error"
                                            app.showDialogError = true
                                        })
                                    })
                                }
                            }
                        })
                    })
                    app.showDialogProgress = false
                    app.showPage = true
                })
                .catch(()=> {
                    app.msgError = "ไม่สามารถดึงข้อมูลได้โปรดติดต่อฝ่าย IT Kiosk : GetRegNumList() has error"
                    app.showDialogError = true
                })
            })
            .catch(()=> {
                app.msgError = "ไม่สามารถดึงข้อมูล Zone ได้โปรดติดต่อฝ่าย IT Kiosk"
                app.showDialogError = true
                // app.showDialogProgress = false
            })
        },

        // ไปหน้าจัดรถ
        manageCar(item){
            let loadDate = ''
            let delDate = ''
            if(item.loadDate){
                let nextLoadDate = new Date(item.loadDate.substr(0,11))
                nextLoadDate.setDate(nextLoadDate.getDate() + 1)
                loadDate = nextLoadDate.toISOString().substr(0,10)
            }
            else{
                loadDate = this.dateStart
            }
            if(item.delDate){
                let nextDelDate = new Date(item.delDate.substr(0,11))
                nextDelDate.setDate(nextDelDate.getDate() + 1)
                delDate = nextDelDate.toISOString().substr(0,10)
            }
            else{
                delDate = this.dateStart
            }
            let routeData = this.$router.resolve({name: 'managecar', query: {
                transNo: item.transNo,
                loadDate: loadDate,
                delDate: delDate,
                driver: item.driver,
                regNum: item.regNum
            }})
            window.open(routeData.href, "_blank")
        },

        // แสดงรายละเอียด
        viewProd(item){
            let app = this
            this.manageList = []
            let result = []
            let i = 0
            item.docEntry.forEach(rec=>{
                axios.post(this.webPath+'deliveryWebService.asmx/GetCar',{
                    docEntry: rec
                })
                .then(response=>{
                    result = JSON.parse(response.data.d)
                    result.forEach(res=>{
                        app.manageList.push(res)
                        i++
                        callback()
                    })
                    // app.manageList.map(x=>{
                    //     x.zip1=x.address1.trim().slice(-5)
                    //     x.zip2=x.address2.trim().slice(-5)
                    //     app.$set(x,"zip3",x.address1.trim().slice(-5))
                    //     return x
                    // })
                    
                })
            })
            let callback = function
            callback(){
                if(item.docEntry.length === i){
                    app.manageList.forEach(a=>{
                        a.docNum = []
                        item.arrDocNum.forEach(b=>{
                            if(a.custName){
                                if(a.custName == b.custName){
                                    a.docNum.push(b.docNum)
                                }
                            }
                            else{
                                if(a.cardName){
                                    if(a.cardName == b.cardName){
                                        a.docNum.push(b.docNum)
                                    }
                                }
                            }
                        })
                    })
                    app.showView = true
                }
            }
        },

        MsDateToDateVue(MsDate){
            if(MsDate==null || MsDate=="/Date(946659600000)/"){
                return null
            }
            let resDate=''
            let cvDate = new Date(parseInt(MsDate.substr(6)))
            
            let Y = cvDate.getFullYear()
            let M = cvDate.getMonth()+1
            let D = cvDate.getDate()

            resDate = D + '/' + (M<10? '0':'') + M + '/' + Y
            // resDate = Y + '-' + (M<10? '0':'') + M + '-' + D

            return resDate
        },
    },
    computed:{
        webPath(){
            return this.$store.getters.webPath
        },
    },
    mounted(){
        if(!sessionStorage.carSmall || !sessionStorage.carLarge){
            this.getRegNum()
        }
        else{
            this.getCarSchedule()
            let small = sessionStorage.carSmall.split(",")
            let large = sessionStorage.carLarge.split(",")

            let arrSmall = [""]
            small.forEach(rec=>{
                arrSmall.push(rec)
            })
            let arrLarge = []
            large.forEach(rec=>{
                arrLarge.push(rec)
            })
            this.itemRegNum = arrSmall.concat(arrLarge)
        }
    }
}
</script>
